import { css } from '@emotion/react';
import cns from 'classnames';
import { FC } from 'react';
import { Icon } from '../Icon';
import { SortType } from './AdvancedTable';

export const TABLE_SORTING_CLASSNAME = '__mapui_tableSorting';

export interface SortingProps {
  className?: string;
  sort: SortType;
  onChangeSorting: Function;
}

const renderIcon = (sort: SortType) => {
  switch (sort) {
    case 'asc':
      return 'sort-up';
    case 'desc':
      return 'sort-down';
    default:
      return 'sort';
  }
};

const applyMainStyles = () => (theme) => {
  const sorting = css(theme.table.sorting);

  const styles = [sorting];

  return css(...styles);
};

export const Sorting: FC<SortingProps> = ({
  className,
  sort = 'unset',
  onChangeSorting,
}: SortingProps) => (
  <Icon
    icon={renderIcon(sort)}
    onClick={() => onChangeSorting(sort)}
    css={applyMainStyles()}
    className={cns(TABLE_SORTING_CLASSNAME, className)}
  />
);
